import produce from 'immer';
import { capitalize } from 'lodash';
import { memo } from 'react';

import { useTrackToggledFieldRequiredStatus } from '@air/analytics';
import { type Form, type FormField } from '@air/api/types';
import { TextEdit as TextEditIcon } from '@air/next-icons';

import { useUpdateForm } from '~/swr-hooks/forms/useUpdateForm';
import { CollectionFormField } from './CollectionFormField';

type SettingsItemProps = {
  formField: FormField;
  form: Form;
};
export const SettingsItem = memo(({ formField, form }: SettingsItemProps) => {
  const fieldName = capitalize(formField?.type);
  const required = formField.required || false;
  const disabled = formField.type === 'title' || form.autoSubmit === true;

  const { trackToggledFieldRequiredStatus } = useTrackToggledFieldRequiredStatus();
  const { updateForm } = useUpdateForm();

  return (
    <CollectionFormField
      onSelect={async (required: boolean) => {
        const updatedFields = produce(form.fields, (draft) => {
          const fieldToUpdate = draft?.find(({ type }) => formField.type === type);
          if (fieldToUpdate) draft?.splice(draft?.indexOf(fieldToUpdate), 1, { ...fieldToUpdate, required: required });
        });

        await updateForm({
          ...form,
          fields: updatedFields,
        });

        trackToggledFieldRequiredStatus({ fieldName: 'Description', required });
      }}
      fieldName={fieldName}
      required={required}
      disabled={disabled}
      leftAdornment={<TextEditIcon className="size-4 text-grey-10" />}
    />
  );
});

SettingsItem.displayName = 'SettingsItem';
